import { formatLocation } from "@/utils/text";
import { TruncatedText } from "./TruncatedText";

export const LocationText = ({ city, state, className, truncate = false }) => {
    if (!city || !state) {
        return <span className={className}>-</span>;
    }

    const location = formatLocation(city, state);

    if (truncate) {
        return <TruncatedText className={className}>{location}</TruncatedText>;
    }

    return <span className={className}>{location}</span>;
};
